export default {
    ruleTemplateData: state => state.ruleTemplateData
}
